class floatingCart extends HTMLElement {
  constructor() {
    super();
    this.height = this.clientHeight;
    document.body.style.paddingBottom = `${this.height}px`;
  }

  connectedCallback() {
    this.onScrollHandler = this.onScroll.bind(this);

    window.addEventListener('scroll', this.onScrollHandler, false);
    this.onScrollHandler();
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScrollHandler);
  }

  reveal() {
    this.setAttribute('animate', '');
  }

  reset() {
    this.removeAttribute('animate');
  }

  getOffsetTop(element) {
    let offsetTop = 0;
    while(element) {
      offsetTop += element.offsetTop;
      element = element.offsetParent;
    }
    return offsetTop;
  }
  onScroll() {
    // let atcObserver = new IntersectionObserver( (entries) => {
    //   entries.forEach(entry => {
    //     if (entry.isIntersecting) {
    //       requestAnimationFrame(this.reset.bind(this));
    //     } else {
    //       requestAnimationFrame(this.reveal.bind(this));
    //     }
    //   });
    // })
    // atcObserver.observe(document.querySelector('.product-section .product-single__meta  .atc-wrapper'));
    const rect = document.querySelector('.product-section .product-single__meta [data-dynamic-variants-enabled]').getBoundingClientRect();
    if(rect.top <= window.innerHeight){
      let atcObserver = new IntersectionObserver( (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            requestAnimationFrame(this.reset.bind(this));
          } else {
            requestAnimationFrame(this.reveal.bind(this));
          }
        });
      })
      atcObserver.observe(document.querySelector('.product-section .product-single__meta  .atc-wrapper'));
    }
    else{
      requestAnimationFrame(this.reset.bind(this));
    }
  }
  reveal() {
    this.setAttribute('animate', '');
  }
  reset() {
    this.removeAttribute('animate');
  }

}
customElements.define('floating-cart',floatingCart)